import { ImageAssetResponse, ImageThumbnail } from 'shared/types/assets'

export interface IVideoConfig {
  enabled: boolean
  min_amount?: string
  max_duration_seconds?: number
}

export interface IAudioConfig {
  enabled: boolean
  max_duration_seconds: number
  min_amount: string
}

export interface IImageConfig {
  enabled: boolean
  min_amount: string
  assets: Omit<ImageAssetResponse, 'is_custom' | 'is_active'>[]
}

export interface IVoice {
  name: string
  nickname: string
  sample_uri: string
}

export interface ITTSVoice {
  language: string
  voices: IVoice[]
}

export interface ITextConfig {
  max_length: number
  min_amount: string
  tts_enabled: boolean
  tts_voices: ITTSVoice[]
}

export type IGoalView = 'percent' | 'current' | 'current_percent' | 'current_target' | 'current_target_percent'

export interface IGoal {
  id?: string
  description?: string
  current?: string
  view?: IGoalView
  target?: string
  deadline_at?: string
  is_default?: boolean
}

export interface IStreamerConfig {
  goals: IGoal[]
  avatar: {
    url: string
    thumbnails: ImageThumbnail[]
  }
  welcome_msg: string
  button_text: string
  base_currency: string
  video_donation_config: IVideoConfig
  audio_donation_config: IAudioConfig
  image_donation_config: IImageConfig
  text_donation_config: ITextConfig
}

export interface ICryptoAmountParams {
  cover_fee: boolean
  nominal_amount: string
  crypto_coin: string
  crypto_network_code: string
  nominal_currency: string
}

export interface ICryptoAmount {
  final_amount: string
  fee: string
}

export interface IFiatAmountParams {
  amount: string
  currency: string
  country: string
  state?: string
}

export interface IFiatProvider {
  payment_method: string
  payment_method_name: string
  provider: string
}

export enum DonationType {
  Text = 'text',
  Audio = 'audio',
}

export enum PaymentType {
  Crypto = 'crypto',
  Fiat = 'fiat',
}

export interface IPostDonation {
  notificationId: string
  redirect_uri: string
}

export interface ICryptoPayment {
  crypto_coin: string | null
  crypto_network_code: string | null
  cover_fee: boolean | null
}

export interface IFiatPayment {
  fiat_payment_method: string | null
  fiat_provider: string | null
}

export interface IPayment extends ICryptoPayment, IFiatPayment {
  type: PaymentType
  /** Fiat currency */
  currency: string | null
  /** Fiat amount */
  amount: string | null
  fiat_country: string | null
  fiat_state?: string
}

export interface IDonation {
  donation_type: DonationType
  donation_text: string | null
  donator_name: string | null
  video_src: string | null
  video_start_from: number | null
  tts_name: string | null
  image_asset_id: string | null
  /** URL to return after payment with donation_id query param */
  origin: string
  payment: IPayment
}

export interface IPostDonationParams {
  donation: IDonation
  audio?: Blob
}
